<template>
  <hm-content>
    <el-form
      ref="ruleForm"
      label-width="100px"
      :model="ruleForm"
      :rules="rules"
    >
      <el-form-item label="负库存超卖">
        <el-switch
          v-model="ruleForm.NegativeStockSale"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="开启"
          inactive-text="关闭"
          active-value="yes"
          inactive-value="no"
        ></el-switch>
      </el-form-item>
      <el-form-item label="扣减库存方法">
        <el-radio-group v-model="ruleForm.ReduceMethod" size="small">
          <el-radio label="online">扣减线上库存</el-radio>
          <el-radio label="offline">扣减线下库存</el-radio>
        </el-radio-group>
        <div class="form-item-tip">
          加入购物车减库存，客户把商品加入购物车时锁定库存数量，可能会存在恶意占用的风险（可以设置购物车有效期，保障库存有效)
        </div>
        <div class="form-item-tip">
          付款减库存，客户下单并付款后减库存，可能会存在超卖风险（超卖订单系统会自动关闭并退款）
        </div>
        <div class="form-item-tip">
          商品参加拼团、秒杀时，默认是付款减库存；且活动库存优先
        </div>
        <div class="form-item-tip">
          门店自提时判断门店库存，非门店自提时，读取商品总库存后再分单
        </div>
      </el-form-item>
      <el-form-item label="库存报警值" prop="WarningValue">
        <el-input
          size="small"
          v-model="ruleForm.WarningValue"
          type="number"
          placeholder="请输入库存预警值"
        ></el-input>
      </el-form-item>
      <el-form-item label="自动分单">
        <el-switch
          v-model="ruleForm.AutoAssignment"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="开启"
          inactive-text="关闭"
          active-value="yes"
          inactive-value="no"
        ></el-switch>
        <div class="form-item-tip">
          开启自动分单时，除了门店自提需要选择门店，其他配送方式不可以选择门店，由系统根据配送距离，商品库存进行优先判断分配订单
        </div>
        <div class="form-item-tip">
          关闭自动分单时，所有配送方式都要选择门店
        </div>
      </el-form-item>
    </el-form>
    <div class="btn-wrapper flex flex-center">
      <el-button size="small" type="primary" @click="save">确 定</el-button>
      <el-button size="small" @click="$router.back(-1)">取 消</el-button>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        NegativeStockSale: "no",
        ReduceMethod: "",
        WarningValue: "",
        AutoAssignment: "no"
      },
      rules: {
        WarningValue: {
          required: true,
          trriger: "blur",
          message: "请输入库存预警值"
        }
      }
    };
  },
  created() {
    this.queryConfig();
  },
  methods: {
    async queryConfig() {
      const { result } = await this.$store.dispatch("getStockMgtConfig");
      result.map(v => {
        for (let key in this.ruleForm) {
          if (key === v.code) {
            this.ruleForm[key] = v.value;
          }
        }
      });
    },
    async save() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        let params = [];
        for (let key in this.ruleForm) {
          params.push({
            value: this.ruleForm[key],
            code: key
          });
        }
        const { code } = await this.$store.dispatch(
          "setStockMgtConfig",
          params
        );
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功！"
          });
        }
      }
    }
  }
};
</script>

<style></style>
